import { Controller } from "@hotwired/stimulus"

export default class PromotePostController extends Controller {
    static targets = ['error']

    errorTargetConnected() {
        if (!this.hasErrorTarget) return

        // scroll up to show the error of payment
        this.errorTarget.scrollIntoView({
            behavior: "smooth",
            block: "center"
        })

        this.errorTarget.focus()
    }

    toggleDisabledState(event) {
        event.preventDefault();
        const $target = $(event.currentTarget);
        const isChecked = $target.prop('checked');
        const isAudienceName = $target.hasClass('audience_name');
        $('.create-audience').toggleClass('disabled', !isChecked && !(isAudienceName && $('.audience_name:checked').length > 0));
        if (isChecked) {
            if (isAudienceName) {
                $('.is_automatic').addClass('disabled').prop('checked', false);
                $('.audience_name').removeClass('disabled');
            } else {
                $('.is_automatic').removeClass('disabled');
                $('.audience_name').addClass('disabled').prop('checked', false);
            }
        }
    }

    changeRangeValue(e) {
        const sliderEl = e.currentTarget
        const amountRangeSpan = document.querySelector("#amount_range");
        const daysRangeSpan = document.querySelector("#days_range");
        const sliderValue = document.querySelector(".value2");
        const sliderDayValue = document.querySelector(".value3");
        const pauseInput = document.querySelector(".is_pause");
        const perDayDiv = document.querySelector(".per-day-total");
        const calculatedDiv = document.querySelector(".calculated-total");

        let tempSliderValue = sliderEl.value;
        let dayInput = document.querySelector("#range3");
        let amountInput = document.querySelector("#range2");
        let calculated_amount = amountInput.value * dayInput.value
        if (e.currentTarget.id === 'range2') {
            amountRangeSpan.textContent = calculated_amount;
            sliderValue.textContent = '$ ' + tempSliderValue;
            if (pauseInput.checked === true) {
                calculatedDiv.classList.add('d-none')
                perDayDiv.classList.remove('d-none')
                perDayDiv.textContent = '$ ' + tempSliderValue + ' per day';
            } else {
                perDayDiv.classList.add('d-none')
                calculatedDiv.classList.remove('d-none')
            }
        } else {
            amountRangeSpan.textContent = calculated_amount;
            daysRangeSpan.textContent = tempSliderValue;
            sliderDayValue.textContent = tempSliderValue + ' days';
        }
        const progress = (tempSliderValue / sliderEl.max) * 100;
        sliderEl.style.background = `linear-gradient(to right, #E85BF4 ${progress}%, #1EC92F ${progress}%)`;
    }

    changeDaysInput(e) {
        const perDayDiv = $(".per-day-total");
        const amountRangeSpan = $(".calculated-total");
        const dayInput = $("#range2");

        if ($(e.target).prop('checked')) {
            $('.duration-field').addClass('disabled')
            perDayDiv.removeClass('d-none')
            amountRangeSpan.addClass('d-none')
            perDayDiv.html('$ ' + dayInput.val() + ' per day')
        } else {
            $('.duration-field').removeClass('disabled')
            amountRangeSpan.removeClass('d-none')
            perDayDiv.addClass('d-none')
        }
    }

    submit(e){
        if($('#card_id').length > 0){
            e.preventDefault()
            this.element.requestSubmit()
        }
    }
}